// Files pasted into a text box (a screenshot copied with Win+Shift+S / Cmd+Ctrl+Shift+4,
// or an image copied from a browser). Returns [] when the clipboard only holds text, so
// callers can leave normal text pastes alone. Clipboard images arrive unnamed
// ("image.png"), so each gets a timestamped name that reads well as an attachment.
//
// Copying text from Word, Excel or Outlook ALSO puts a picture of that text on the
// clipboard. If the clipboard carries text, it is a text paste — return [] so the
// words land in the box instead of being swapped for an image of them.
export function filesFromPaste(e) {
  if ((e.clipboardData?.getData("text/plain") || "").trim()) return [];
  const items = Array.from(e.clipboardData?.items || []);
  const stamp = new Date().toISOString().replace(/[-:]/g, "").replace("T", "-").slice(0, 15);
  return items
    .filter(it => it.kind === "file")
    .map(it => it.getAsFile())
    .filter(Boolean)
    .map((f, i) => {
      if (f.name && f.name !== "image.png") return f;
      const ext = (f.type.split("/")[1] || "png").replace("jpeg", "jpg");
      return new File([f], `screenshot-${stamp}${i ? `-${i + 1}` : ""}.${ext}`, { type: f.type });
    });
}

// The server accepts at most 10 files per message, 20 MB each (multer limits in the
// backend). Checking here tells the person why a file was left out, instead of the
// whole message failing on upload.
export const MAX_FILES   = 10;
export const MAX_FILE_MB = 20;

export function addWithinLimits(current, incoming) {
  const files = [...current];
  const notes = [];
  for (const f of incoming) {
    if (f.size > MAX_FILE_MB * 1024 * 1024) { notes.push(`${f.name} is larger than ${MAX_FILE_MB} MB.`); continue; }
    if (files.length >= MAX_FILES) { notes.push(`Only ${MAX_FILES} files can go with one message.`); break; }
    files.push(f);
  }
  return { files, notes };
}

export function fmtFileSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
